import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { getToken, subscribeAuth } from "../auth/store";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const [token, setToken] = useState(getToken());
  useEffect(() => subscribeAuth(() => setToken(getToken())), []);
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
